import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'userSms/'

export const userSmsService = {
  addUserSmsByUserType
}

function addUserSmsByUserType(dto) {
  const url = base_url + model + 'addUserSmsByUserType'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}
